import React from 'react';
import { Box } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { InviteUserForm } from 'modules/multi-user/components/invite-user-form/invite-user-form';
import { FeatureFlag, FeatureFlags } from 'utils/feature-flags';
import { UserRole } from 'modules/2023-q4/rbac/enums/user-role';
import { UserPermissionsRequired } from 'modules/2023-q4/rbac/components/user-permissions-required/user-permissions-required';

const InviteUserContent: React.FC = () => (
  <>
    <Box mb={3}>
      <Typography variant={TypographyVariant.SubHeader3}>
        Invite additional team members to access this account, request
        transfers, and view cash flow insights. These users will receive an
        invitation to their email to setup their access.
      </Typography>
    </Box>

    <InviteUserForm />
  </>
);

export const InviteUser: React.FC = () => {
  return (
    <FeatureFlag
      disabled={<InviteUserContent />}
      enabled={
        <UserPermissionsRequired roles={[UserRole.ADMIN]}>
          <InviteUserContent />
        </UserPermissionsRequired>
      }
      flag={FeatureFlags.REACT_APP_2023_Q4_USER_ROLES_ENABLED}
    />
  );
};
